module.exports = __webpack_public_path__ + "media/message.c89777b1.wav";